import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../login/login.service';

@Injectable({
    providedIn: 'root'
})
export class SecureInnerPagesGuard implements CanActivate {
    constructor(
        public loginService: LoginService,
        public router: Router
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
            if (this.loginService.isLoggedIn()) {
                if (this.loginService.landingPage()) {
                    this.router.navigate(['/dashboard']);
                }
                else{
                    if (this.loginService.loggedType()) {
                        this.router.navigate(['/clienthome']);
                    } else {
                        this.router.navigate(['/home']);
                    }    
                }
            }
        return true;
    }  
}
